var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.843 4.568a8.708 8.708 0 0112.315 12.314l-1.188 1.174c-.875.859-2.01 1.963-3.406 3.313a2.25 2.25 0 01-3.128-.001l-3.491-3.396c-.439-.43-.806-.794-1.102-1.09a8.71 8.71 0 010-12.314zM17.096 5.63A7.208 7.208 0 106.904 15.822l1.487 1.467a743.496 743.496 0 003.088 3 .75.75 0 001.043 0l3.394-3.3c.47-.46.863-.849 1.18-1.167a7.207 7.207 0 000-10.192zM12 7.5a3.5 3.5 0 11-.002 7 3.5 3.5 0 01.002-7zM12 9a2 2 0 100 4 2 2 0 000-4z",
    fill: "#333230"
  })));
}
export default SvgLocationNew;